import React, { useState, useEffect, useContext, useRef } from "react";
import { Dropdown, Badge, Popover, OverlayTrigger, Button, Pagination, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";

import LifetimeAlert from '../LifetimeAlert/LifetimeAlert';

import axios from 'axios';
import { baseURL } from "../../../baseURL";
import Cookies from 'js-cookie';

import {SetBackgroundTheme} from "../../setBackgroundTheme";
import CheckAuth from "../CheckAuth";

const DownloadLeadsStateTable = ({ taskIdState }) => {
  
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  
  const [activeIntegrationId, setActiveIntegrationId] = useState(0);
  const [activeIntegrationPlatform, setActiveIntegrationPlatform] = useState("");
  const activeIntegrationIdRef = useRef(0);
  

  const [loadingClosedPositions, setLoadingClosedPositions] = useState(true);
  const [loadingOpenPositions, setLoadingOpenPositions] = useState(true);
  

  const [active, setActive] = useState(1);
  const [maxPage, setMaxPage] = useState(2);
  const [pageItems, setPageItems] = useState([{p:1}]);
  const [loadingBadge, setLoadingBadge] = useState(false);
  const [maxAvailablePage, setMaxAvailablePage] = useState(1);

  const [themeName, setThemeName] = useState('light');

  const { changeBackground, background } = useContext(ThemeContext);
  useEffect(() => {
    getAllTasks(1);
  }, [taskIdState]);

  useEffect(() => {
    setThemeName(background.value);
  }, [background]);

  function setNavigationLinks(max_page) {
    var page_items_tmp = [];
    var index = 0;
    for (let number = active; number <= max_page; number++) {
        index += 1;
        if(index >= 7) {
          break;
        }
        page_items_tmp.push({p:number});
    }
    setPageItems(page_items_tmp);
  }

  function changePage(page) {
    setLoadingBadge(true);
    var page_number = parseInt(page);
    setActive(page_number);

    var number_first = 1;
    var max_page = maxPage;
    if(page_number > 5) {
      number_first = page_number - 5;
      max_page = max_page + number_first;
      if(max_page > maxAvailablePage){
        max_page = maxAvailablePage;
      }
    }

    var page_items_tmp = [];
    var index = 0;
    for (let number = number_first; number <= max_page; number++) {
        page_items_tmp.push({p:number});
        index += 1;
        if(index >= 7) {
          break;
        }
    }
    setPageItems(page_items_tmp);
    getAllTasks(page_number);
  }

  function changePageNoReload(page, max_page) {
    setLoadingBadge(true);
    var page_number = parseInt(page);
    setActive(page_number);

    var number_first = 1;
    if(page_number > 5) {
        number_first = page_number - 5;
        max_page = max_page + number_first;
    }

    var page_items_tmp = [];
    var index = 0;
    for (let number = number_first; number <= max_page; number++) {
        page_items_tmp.push({p:number});
        index += 1;
        if(index >= 7) {
          break;
        }
    }
    setPageItems(page_items_tmp);
  }

  function changePagePrev() {
    var next_page = active - 1;
    if(next_page < 1) {
      next_page = 1;
    }
    setActive(next_page);
    changePage(next_page);
  }

  function changePageNext() {
    const next_page = active + 1;
    if(next_page <= maxAvailablePage) {
      setActive(next_page);
      changePage(next_page);
    }
  }

  async function getAllTasks(page_number) {
    setLoadingBadge(true);
    const data = {
      token: Cookies.get('token'),
      page: page_number,
      task_id: taskIdState
    }

    try {
      const response = await axios.post(baseURL+'/api/dashboard/get_results_subtask', data);
      if(response.data.status === 'ok') {
        console.log("response.data.results: ", response.data.results)
        setResults(response.data.results);

        setNavigationLinks(response.data.max_page);
        setMaxAvailablePage(response.data.max_page);
        setMaxPage(response.data.max_page);
        changePageNoReload(page_number, response.data.max_page);

      } else {
        // setError(response.data.text);
      }
    } catch(err) {

    }
    setLoadingBadge(false);
    setLoadingClosedPositions(false);
  }

  return (
    <>
      {loading === true && (
        <Badge variant="info light">Loading...</Badge>
      )}

      {loading === false && (
        <div className="row">
          <div className="col-xl-12">
            <div className="table-responsive table-hover fs-14 ">
              <div id="example6_wrapper" className="dataTables_wrapper no-footer">

                {/* <div className="d-none d-sm-block"> */}
                <div className="">
                  <table
                    className="table display mb-4 dataTablesCard font-w600 short-one border-no card-table text-black dataTable no-footer"
                    id="marketCapital"
                    role="grid"
                    aria-describedby="example6_info"
                  >
                    <thead>
                      <tr role="row">
                        <th>Task ID</th>
                        <th>Search Request</th>
                        <th>Location</th>
                        <th>Status</th>
                        <th>Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      {results.length > 0 &&
                        results.map((item, i) => (
                          <tr role="row" key={i} className="odd">
                            <td className="wspace-no sorting_1">
                              <span>#{item.task_id}</span>
                            </td>
                            <td className="wspace-no sorting_1">
                              <span>{item.input_data.search}</span>
                            </td>
                            <td className="wspace-no sorting_1">
                              <span>{item.input_data.city}, {item.input_data.state} {item.input_data.country}</span>
                            </td>
                            <td className="wspace-no sorting_1">
                              {item.completed === true && (
                                <Badge variant="success light">Completed</Badge>
                              )}
                              {item.completed === false && (
                                <Badge variant="warning light">{item.step}</Badge>
                              )}
                            </td>
                            <td className="wspace-no sorting_1">
                              {item.completed === true && (
                                <a href={item.csv_url} className="btn btn-sm btn-primary" target="_blank" rel="noopener noreferrer">
                                  Download CSV
                                </a>
                              )}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="">
              <Pagination
                size="sm"
                className={`mt-4 pagination-gutter pagination-primary no-bg pagination-circle`}
              >
                <li className="page-item page-indicator">
                  <Link className="page-link" to="#" onClick={() => changePagePrev()}>
                    <i className="la la-angle-left" />
                  </Link>
                </li>

                {pageItems.length > 0 &&
                  pageItems.map((item, i) => (
                    <Pagination.Item key={i} active={item.p === active ? true : false} onClick={() => {changePage(item.p)}}>
                      {item.p}
                    </Pagination.Item>
                  )
                )}
                
                <li className="page-item page-indicator">
                  <Link className="page-link" to="#" onClick={() => changePageNext()}>
                    <i className="la la-angle-right" />
                  </Link>
                </li>
              </Pagination>

              {loadingBadge === true && (
                <div className="mt-3">
                  <Badge variant="info light">Loading</Badge>
                </div>
              )}
              
            </div>

          </div>
        </div>
      )}

    </>
  );
};

export default DownloadLeadsStateTable;
